import * as JSJoda from '@js-joda/core';
import Logging from '../Logging/Logging';

// Convert Local Time to UTC Time
export function localToUtc(date: Date): Date {
  return date ? new Date(date.getTime() + (date.getTimezoneOffset() * 60 * 1000)) : null;
}

// Convert UTC to Local Time
export function utcToLocal(date: Date): Date {
  return date ? new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000)) : null;
}

// Get the Current Date without Time, adjusted to the local Timezone.
// If current date was 2021-02-11 this would return 'Wed Feb 10 2021 19:00:00 GMT-0500 (Eastern Standard Time)'
export function getCurrentDateOnly(): Date {
  // Get current date / time
  const today = new Date();

  // Remove the Time
  today.setHours(0, 0, 0, 0);

  // Adjust for Local
  return utcToLocal(today);
}

// Input Date is considered to be in UTC
// Sample Dates: 2020-04-17T16:47Z, 2020-05-20, 20200321
export function stringToDate(value: string): Date {
  if (!value) return null;

  try {
    // YYYY-MM-DD format
    // This Date is already in Local Format. do not convert from UTC to Local
    if (value.length === 10) {
      const year = value.substr(0, 4);
      const month = value.substr(5, 2);
      const day = value.substr(8, 2);

      const date = new Date(Date.UTC(Number.parseInt(year, 10), Number.parseInt(month, 10) - 1, Number.parseInt(day, 10)));
      return date;
    }

    let parsedDate: number = Date.parse(value);

    // Parse Failed
    if (Number.isNaN(parsedDate)) {
      // Try YYYYMMDD
      if (value.length === 8) {
        const year: string = value.substr(0, 4);
        const month: string = value.substr(4, 2);
        const day: string = value.substr(6, 2);

        parsedDate = Date.parse(`${year}-${month}-${day}`);
      } else if (value.length === 22) { // 20200428T03:33:51.900Z
        const year: string = value.substr(0, 4);
        const month: string = value.substr(4, 2);
        const day: string = value.substr(6, 2);

        parsedDate = Date.parse(`${year}-${month}-${day}${value.substr(8)}`);
      } else if (value.length === 28) { // 2020-05-27T13:01:28.764+0000
        const year: string = value.substr(0, 4);
        const month: string = value.substr(5, 2);
        const day: string = value.substr(8, 2);
        const hour: string = value.substr(11, 2);
        const minute: string = value.substr(14, 2);

        parsedDate = Date.parse(`${year}-${month}-${day}T${hour}:${minute}Z`);
      } else {
        Logging.Warning('Unable to Parse String date', value);

        return null;
      }
    }

    const date = new Date(parsedDate);

    Logging.Debug('stringToDate', value, parsedDate, date);

    return date;
  } catch (e) {
    Logging.Warning('Unable to Parse String date', value);

    return null;
  }
}

export function jsJodaLocalDateToJavascriptDate(date: JSJoda.LocalDate): Date {
  if (date) {
    const newDate: Date = new Date(date.year(), date.monthValue() - 1, date.dayOfMonth(), 0, 0, 0);

    return utcToLocal(newDate);
  }

  return null;
}
